"use strict";

require("core-js/modules/es.symbol");

require("core-js/modules/es.symbol.description");

require("core-js/modules/es.symbol.iterator");

require("core-js/modules/es.array.concat");

require("core-js/modules/es.array.index-of");

require("core-js/modules/es.array.iterator");

require("core-js/modules/es.function.name");

require("core-js/modules/es.object.assign");

require("core-js/modules/es.object.get-prototype-of");

require("core-js/modules/es.object.keys");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.reflect.construct");

require("core-js/modules/es.regexp.exec");

require("core-js/modules/es.regexp.to-string");

require("core-js/modules/es.string.iterator");

require("core-js/modules/es.string.split");

require("core-js/modules/web.dom-collections.iterator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Control = _interopRequireDefault(require("@icare/rhythm-form-react/lib/elements/Control"));

var _moment = _interopRequireDefault(require("moment"));

var _reactMaskedinput = _interopRequireDefault(require("react-maskedinput"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/*const mask = rawValue => {
	const secondMask = rawValue && rawValue.charAt(0) === '0' ? /[0-9]/ : /[0-2]/;
	return [/[0-1]/, secondMask, ':', /[0-5]/, /[0-9]/];
};*/
var mask = '11:11';
var AM_PM = {
  AM: 'am',
  PM: 'pm'
};
var HOURS_FORMAT = {
  H24: 'HH:mm',
  H24_AMPM: 'HH:mm A',
  H12: 'hh:mm',
  H12_AMPM: 'hh:mm A'
};
var HOURS_MAX = 12;
var MINS_MAX = 60;

var TimePicker = /*#__PURE__*/function (_React$Component) {
  _inherits(TimePicker, _React$Component);

  var _super = _createSuper(TimePicker);

  function TimePicker(props) {
    var _this;

    _classCallCheck(this, TimePicker);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "handleInputChange", function (e) {
      _this.setState({
        inputValue: e.target.value
      }, function () {
        _this.handleChange();
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleAmPmChange", function (e) {
      _this.setState({
        amPm: e.target.value
      }, function () {
        _this.handleChange();
      });
    });

    _defineProperty(_assertThisInitialized(_this), "checkTime", function (inputValue, _amPm) {
      var timeArray = inputValue.split(':');
      var hours = timeArray[0];
      var mins = timeArray[1];

      if (!isNaN(parseInt(hours)) && parseInt(hours) <= HOURS_MAX && !isNaN(parseInt(mins)) && parseInt(mins) <= MINS_MAX) {
        return true;
      }

      return false;
    });

    _defineProperty(_assertThisInitialized(_this), "handleChange", function () {
      var onChange = _this.props.onChange;
      var _this$state = _this.state,
          inputValue = _this$state.inputValue,
          amPm = _this$state.amPm;

      if (_this.checkTime(inputValue, amPm)) {
        var formattedValue = (0, _moment.default)("".concat(inputValue, " ").concat(amPm), HOURS_FORMAT.H12_AMPM).format(HOURS_FORMAT.H24);
        onChange(formattedValue);
      } else {
        onChange('INVALID_TIME');
      }
    });

    var value12 = '';
    var _amPm2 = AM_PM.AM;

    if ((0, _moment.default)(props.value, HOURS_FORMAT.H24, true).isValid()) {
      value12 = (0, _moment.default)(props.value, HOURS_FORMAT.H24, true).format(HOURS_FORMAT.H12);
      _amPm2 = (0, _moment.default)(props.value, HOURS_FORMAT.H24, true).get('hour') > 12 ? AM_PM.PM : AM_PM.AM;
    }

    _this.state = {
      inputValue: value12,
      amPm: _amPm2
    };
    return _this;
  }

  _createClass(TimePicker, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          error = _this$props.error,
          status = _this$props.status,
          statusMessage = _this$props.statusMessage,
          name = _this$props.name,
          inputFormatSuggestion = _this$props.inputFormatSuggestion,
          attr = _objectWithoutProperties(_this$props, ["error", "status", "statusMessage", "name", "inputFormatSuggestion"]);

      var _this$state2 = this.state,
          inputValue = _this$state2.inputValue,
          amPm = _this$state2.amPm; // Send error through to ctrl-holder

      var _status = !!error ? 'error' : status;

      var _statusMessage = !!error ? error : statusMessage;

      return /*#__PURE__*/_react.default.createElement(_Control.default, _extends({}, attr, {
        name: name,
        status: _status,
        statusMessage: _statusMessage,
        inputFormatSuggestion: inputFormatSuggestion,
        className: "time-picker"
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: "time-picker__input-wrapper"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "text-input"
      }, /*#__PURE__*/_react.default.createElement(_reactMaskedinput.default, {
        mask: mask,
        placeholderChar: "-",
        placeholder: "",
        id: "".concat(name, "__input"),
        onChange: this.handleInputChange,
        value: inputValue
      })), /*#__PURE__*/_react.default.createElement("div", {
        className: "select-input"
      }, /*#__PURE__*/_react.default.createElement("select", {
        value: amPm,
        onChange: this.handleAmPmChange
      }, /*#__PURE__*/_react.default.createElement("option", {
        value: AM_PM.AM
      }, AM_PM.AM.toUpperCase()), /*#__PURE__*/_react.default.createElement("option", {
        value: AM_PM.PM
      }, AM_PM.PM.toUpperCase())))));
    }
  }]);

  return TimePicker;
}(_react.default.Component);

exports.default = TimePicker;

_defineProperty(TimePicker, "defaultProps", {
  error: null,
  statusMessage: null,
  status: null,
  value: null,
  placeholder: HOURS_FORMAT.H12,
  inputFormatSuggestion: '',
  name: null,
  onChange: function onChange() {}
});

_defineProperty(TimePicker, "propTypes", {
  error: _propTypes.default.string,
  placeholder: _propTypes.default.string,
  inputFormatSuggestion: _propTypes.default.string,
  name: _propTypes.default.string,
  status: _propTypes.default.string,
  statusMessage: _propTypes.default.string,
  value: _propTypes.default.string,
  onChange: _propTypes.default.func
});
//# sourceMappingURL=TimePicker.js.map